import React from 'react';
import { GLOBAL_THEME_COLOR } from '@constants/theme';
import { Reservation } from '@core/models';
import { Card, Col, Row, Space } from 'antd';
import { CardSectionHeader, ReservationListCard, ReservationListColumnHeader } from '..';
import { MIDDLE_STYLE } from '@constants/responsive';
import ReservationStateObserver from '@components/ReservationStateObserver';

type Props<T> = {
  title: string;
  reservations: Reservation<T>[];
  renderExtraParams?: (reservation: Reservation<T>) => React.ReactNode[] | React.ReactNode;
  renderExtraParamsHeader?: () => React.ReactNode[] | React.ReactNode;
};

function ReservationGroupedContainer<T>({
  title,
  reservations,
  renderExtraParams,
  renderExtraParamsHeader,
}: Props<T>) {
  return reservations.length > 0 ? (
    <Card className="no-padding" style={{ padding: 0, width: '100%', overflow: 'hidden' }}>
      <div
        style={{
          backgroundColor: GLOBAL_THEME_COLOR.$dark_background_color,
          padding: '10px 15px',
          borderBottom: `1px solid ${GLOBAL_THEME_COLOR.$border_color}`,
        }}>
        <CardSectionHeader title={`${title} (${reservations.length})`} />
      </div>
      <Row
        gutter={20}
        style={{
          ...MIDDLE_STYLE,
          width: '100%',
          padding: '5px 15px',
        }}>
        <Col span={3}>
          <ReservationListColumnHeader title="date" />
        </Col>
        <Col span={2}>
          <ReservationListColumnHeader title="customer" />
        </Col>
        <Col span={4}>
          <ReservationListColumnHeader title="full name" />
        </Col>
        <Col span={3}>
          <ReservationListColumnHeader title="status" />
        </Col>
        <Col span={2}>
          <ReservationListColumnHeader title="pax" />
        </Col>
        <Col span={5}>{renderExtraParamsHeader && renderExtraParamsHeader()}</Col>
        <Col span={5}></Col>
      </Row>
      <Space direction="vertical" style={{ width: '100%' }}>
        {reservations.map(reservation => (
          <ReservationStateObserver reservation={reservation}>
            <ReservationListCard
              key={reservation.id}
              reservation={reservation}
              renderExtraParams={renderExtraParams}
            />
          </ReservationStateObserver>
        ))}
      </Space>
    </Card>
  ) : (
    <></>
  );
}

export default ReservationGroupedContainer;
